export default __webpack_public_path__ + "static/media/archi_slider_9.8a0a48f9.webp";